/** @format */

import React from 'react';

export const Unit = ({
  krFields = [],
  krPerHourFields = [],
  areaFields = [],
  facts = {},
  unit: unitProp = null,
  kwhFields = []
}) => {
  let unit = unitProp;

  if (krFields.includes(facts?.factFieldName)) {
    unit = 'Kr';
  } else if (krPerHourFields.includes(facts?.factFieldName)) {
    unit = 'Kr/år';
  } else if (areaFields.includes(facts?.factFieldName)) {
    unit = 'Kvm';
  } else if (kwhFields.includes(facts?.factFieldName)) {
    unit = 'KWH';
  }

  if (unit) {
    return <span className='facts-unit'>{unit}</span>;
  }

  return <></>;
};
